/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_PublishInputs */

const en_mk_nav_publish = /** @type {(inputs: Mk_Nav_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish & hand over`)
};

const id_mk_nav_publish = /** @type {(inputs: Mk_Nav_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terbitkan & serahkan`)
};

/**
* | output |
* | --- |
* | "Publish & hand over" |
*
* @param {Mk_Nav_PublishInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_publish = /** @type {((inputs?: Mk_Nav_PublishInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_PublishInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_publish(inputs)
	return en_mk_nav_publish(inputs)
});